module.exports = __webpack_public_path__ + "static/media/graph.7d5f0ebf.png";